import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Grid } from "@mui/material";
import { BodyContent, BodyHeading, Body } from "@thrivetribe/mvf.ui.organisms.body";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { ArticleCard } from "@thrivetribe/mvf.ui.molecules.article-card";
import { BannerSlider } from "@thrivetribe/mvf.ui.organisms.banner-slider";
import Hero from "ui/organisms/Hero/Hero";
import { useUser } from "components/user/UserContext";
import { useGetBannersQuery, useGetArticlesQuery } from "redux/contentApiSlice";
import "./Homepage.scss";
import { LoadingSpinner } from "@thrivetribe/mvf.ui.molecules.loading-spinner";
import { ImagesUrl } from "configs/EnvironmentConfig";

export const Homepage: React.FC = () => {
  const user = useUser().user;
  const { data: banners, isLoading: isBannerLoading } = useGetBannersQuery({
    limit: 6,
    pageRequested: 1,
    publicTags: ["home"],
  });
  const { data: articles, isLoading: isArticleLoading } = useGetArticlesQuery({
    limit: 2,
    pageRequested: 1,
    tagType: "journeyTags",
    tags: ["PreSeason", "FirstSeason"],
    contentOrderSelection: "Random",
  });

  if (isBannerLoading || isArticleLoading) {
    return <LoadingSpinner fullscreen={false} />;
  }

  return (
    <Body>
      <Helmet>
        <title>Home - MAN v FAT</title>
      </Helmet>

      <BodyHeading>
        <h1>
          Hey {user?.personalDetails.firstName},<br /> welcome to MAN v FAT
        </h1>
      </BodyHeading>

      <BodyContent>
        <section className="homepage">
          <Hero
            title={"Welcome to The Dugout"}
            body={
              <>
                <p>
                  We're so excited to have you joining us in The Dugout. Explore our weight loss tips and tricks, or
                  cook up a banging meal with some of our weight loss friendly recipes. We've got big plans underway to
                  bring you more features soon so watch this space.
                </p>
                <span>MAN v FAT HQ team</span>
              </>
            }
            imageSrc={`${ImagesUrl}/home-hero.webp`}
            imageAlt={"MAN v FAT"}
          />

          {banners && banners.length > 0 && (
            <div className="carousel">
              <BannerSlider content={banners} />
            </div>
          )}

          {articles && (
            <section className="homepage__level-up">
              <Grid container>
                <Grid item sm={12} md={12} lg={4} className="homepage__level-up__info">
                  <div className="homepage__level-up__info__header">
                    <h1>MAN v FAT Basics</h1>
                    <Link to={"/article-list/pre-season"}>
                      <Button variant="text">
                        Browse more <ButtonArrow />
                      </Button>
                    </Link>
                  </div>
                  <p>
                    New to MAN v FAT Football, coming back to football and activity after a long break, or simply after
                    tips to prepare for your next season? We've got plenty of articles packed with juicy details to help
                    you on your path to weight loss success.
                  </p>
                </Grid>
                <Grid item sm={12} md={12} lg={8}>
                  <Grid container spacing={2}>
                    {articles.map((article, index) => (
                      <Grid item sm={12} md={6} lg={6} key={index}>
                        <ArticleCard
                          title={article.title}
                          description={article.body}
                          imgUrl={article.asset.file.url}
                          imgTitle={article.asset.title}
                          onClick={() => {
                            window.location.href = `/articles/${article.slug}`;
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </section>
          )}
        </section>
      </BodyContent>
    </Body>
  );
};
